import "./AboutAnushthan.css";

import Rohan from "../assests/images/Rohan-Sir.png";
import Prachi from "../assests/images/Prachi-Ma'am.png";
import Amit from "../assests/images/Amit Sir.jpg";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const AboutAnushthan = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const [showAllRohanProfile, setShowAllRohanProfile] = useState(false);
  const [showAllPrachiProfile, setShowAllPrachiProfile] = useState(false);
  const [showAllAmitProfile, setShowAllAmitProfile] = useState(false);

  const handleRohanReadMore = () => {
    setShowAllRohanProfile(true);
  };
  const handleRohanReadLess = () => {
    setShowAllRohanProfile(false);
  };

  const handlePrachiReadMore = () => {
    setShowAllPrachiProfile(true);
  };
  const handlePrachiReadLess = () => {
    setShowAllPrachiProfile(false);
  };

  const handleAmitReadMore = () => {
    setShowAllAmitProfile(true);
  };
  const handleAmitReadLess = () => {
    setShowAllAmitProfile(false);
  };

  return (
    <>
      <section
        id="aboutus"
        className={`about-us-container ${isHome && "bg-yellow"}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="subtitle-text2">Who are we?</h1>
            </div>
            {/* <div className="col-12 mt-3">
              <h3 className="subtitle-text">
                Built for Speed. Wired for impact.
              </h3>
            </div>
            <div className="col-12">
              <h3 className="subtitle-text">
                Creating what the future looks like.
              </h3>
            </div> */}
            <div className="col-12 mt-3">
              <p className={`content ${isHome ? 'text-white': ''} fs-4 fw-bold`}>
                We're a digital-first creative lab where technology, design, and
                ideas collide to shape what's next. <br/> At Anushthan, we believe the
                future belongs to brands that dare to build - smarter, faster,
                and with purpose. From Al-powered content to immersive
                storytelling, performance marketing to intuitive design, we
                create with clarity, ambition, and the future in mind. We don't
                catch up. We move forward.
              </p>
            </div>

            {isHome === false && (
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
                <div className="col d-flex">
                  <div className="team-card w-100">
                    <div className="team-card-image-container">
                      <img
                        src={Rohan}
                        className="team-card-image"
                        alt={`Team Member `}
                      />
                      <span className="team-member-name-tag">
                        Rohan Mahajan
                      </span>
                    </div>
                    <div className="team-card-body">
                      <div className="team-card-number"></div>
                      <h5 className="team-card-title">Founder & Director</h5>
                      <p className="team-card-description">
                        At the forefront of Idea Labs is Rohan Mahajan, a
                        visionary leader with a multidisciplinary edge. With a
                        background as a lawyer, political consultant, and
                        national campaign strategist.
                        {showAllRohanProfile === true && (
                          <span>
                            Rohan brings sharp strategic thinking and deep
                            experience in governance and public communication to
                            the digital space. Holding a Masters in Sustainable
                            Development and a PGDM in Governance, he blends
                            policy insight with a passion for innovation.
                            Rohan’s journey from national-level campaigns to
                            launching Idea Labs is rooted in one belief:
                            creativity must deliver results. An avid sports
                            enthusiast and disciplined practitioner of yoga and
                            pranayam, he embodies balance—between art and
                            analytics, vision and execution. Under his
                            leadership, Idea Labs has grown into a full-spectrum
                            digital powerhouse, fusing design, content,
                            strategy, and technology to craft impactful brand
                            experiences.
                            <button
                              onClick={handleRohanReadLess}
                              className="btn btn-link"
                            >
                              Read Less
                            </button>
                          </span>
                        )}
                        {showAllRohanProfile === false && (
                          <button
                            onClick={handleRohanReadMore}
                            className="btn btn-link"
                          >
                            Read More
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col d-flex">
                  <div className="team-card w-100">
                    <div className="team-card-image-container">
                      <img
                        src={Prachi}
                        className="team-card-image"
                        alt={`Team Member `}
                      />
                      <span className="team-member-name-tag">
                        Prachi Sharma
                      </span>
                    </div>
                    <div className="team-card-body">
                      <div className="team-card-number"></div>
                      <h5 className="team-card-title">Founder & Director</h5>
                      <p className="team-card-description">
                        As the founder of Anushthan Idea Labs, Vizinfy, and
                        Pikaball, I specialize in crafting Al-, AR/VR-enabled
                        marketing campaigns, software platforms, and educational
                        tools that are both culturally relevant and
                        future-ready.
                        {showAllPrachiProfile === true && (
                          <span>
                            Awards & Thought Leadership:
                            <li>
                              Emerging Women Entrepreneur Award 2020 - MEME
                            </li>
                            <li>Chamber of Commerce & Industry of India </li>
                            <li>
                              Speaker & Panelist at Microsoft's 'Future Fem -
                              Educate, Innovate, Accelerate' - Shared the stage
                              with leading women entrepreneurs on innovation and
                              impact
                            </li>
                            <li>
                              Guest Lecturer at IIT Mandi, School of Management
                              - Engaged with future leaders on innovation,
                              entrepre-neurship, and purpose-driven ventures
                            </li>
                            <li>
                              Featured in Silicon India Magazine - Al/AR-based
                              brand transformation
                            </li>
                            <li>
                              Featured in Business View Magazine - ARkives:
                              Augmented schoolbooks for immersive education
                            </li>
                            <li>
                              ExchangeMedia & Impact Magazine - Contactless
                              shopping tech & retail campaigns using Al/AR
                            </li>
                            <li>
                              CIO News (2022) - Voice-tech innovation and
                              digital youth upskilling.
                            </li>
                            <button
                              onClick={handlePrachiReadLess}
                              className="btn btn-link"
                            >
                              Read Less
                            </button>
                          </span>
                        )}
                        {showAllPrachiProfile === false && (
                          <button
                            onClick={handlePrachiReadMore}
                            className="btn btn-link"
                          >
                            Read More
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col d-flex">
                  <div className="team-card w-100">
                    <div className="team-card-image-container">
                      <img
                        src={Amit}
                        className="team-card-image"
                        alt={`Team Member`}
                        style={{ objectPosition: "top" }}
                      />
                      <span className="team-member-name-tag">
                        Amit Aggarwal
                      </span>
                    </div>
                    <div className="team-card-body">
                      <div className="team-card-number"></div>
                      <h5 className="team-card-title">Business Partner</h5>
                      <p className="team-card-description">
                        Introducing Mr. Amit Agarwal, the visionary behind
                        Beatit Entertainment! For the past 12 years, his
                        leadership has elevated our company to new heights.
                        {showAllAmitProfile === true && (
                          <span>
                            {" "}
                            Under his direction, we have successfully managed
                            major events like the ICC World Cup 2023 , FIFA U-17
                            WORLD CUP 2017, IPL and many more.As we celebrate 12
                            years of excellence, we extend our gratitude for his
                            guidance andunwaver-ing support. His vision and
                            dedication have been pivotal to our
                            success,fostering a close-knit, thriving team.
                            Here's to many more years of growth,collaboration,
                            and achievement under his inspiring leadership.
                            <button
                              onClick={handleAmitReadLess}
                              className="btn btn-link"
                            >
                              Read Less
                            </button>
                          </span>
                        )}
                        {showAllAmitProfile === false && (
                          <button
                            onClick={handleAmitReadMore}
                            className="btn btn-link"
                          >
                            Read More
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutAnushthan;
